import {Box} from 'platform/foundation';

import {SyncedMessages} from './components/SyncedMessages';

export function EmailSynchronization() {
  return (
    <Box
      width="100%"
      height="100%"
      padding={4}
      backgroundColor="general.white"
      data-testid="integrations-emailSynchronization-settings"
    >
      <SyncedMessages data-testid="emailSynchronization" />
    </Box>
  );
}
